import { ClientModel } from '../../app/modules/client/models/ClientModel'
import { CreatePersonModel } from '../../models/person/CreatePersonModel'
import { PersonModel } from '../../models/person/PersonModel'
import { baseApi } from '../api/base'
import { EntityFilterParams, paramSerializer } from '../api/params'
import { keysToSnake } from '../utils/caseConverter'

const clientApi = baseApi('/clients')

const list = async (params?: EntityFilterParams): Promise<ClientModel[]> => {
	return (await clientApi.get('', { paramsSerializer: paramSerializer, params })).data.data
}

const create = async (person: CreatePersonModel): Promise<ClientModel> => {
	const {
		city,
		complement,
		country,
		district,
		document,
		email,
		fancyName,
		mobileNumber,
		name,
		phoneNumber,
		postalCode,
		role,
		state,
		stateRegistry,
		street,
		streetNumber,
		stateRegistryIsento,
	} = person

	const newClient: Partial<PersonModel> = {
		role,
		name,
		phoneNumber,
		mobileNumber,
		email,
	}

	role == 1
		? (newClient.company = {
				document,
				stateRegistry: stateRegistryIsento ? 'ISENTO' : stateRegistry,
				fancyName,
		  })
		: (newClient.individual = {
				document,
				stateRegistry,
		  })

	newClient.addresses = [
		{
			street,
			streetNumber,
			district,
			postalCode,
			complement,
			cityLocation: {
				city,
				state,
				country,
			},
		},
	]

	const payload = {
		person: newClient,
	}

	return (await clientApi.post('', keysToSnake(payload))).data
}

const del = async (id: number) => {
	return await clientApi.delete(id.toString())
}

export const ClientService = {
	list,
	create,
	del,
}
